import{lazy as o}from"react";export{default as GoogleAnalytics}from"./ga.js";const t=o((()=>import("./pixel.js"))),r=o((()=>import("./moengage.js"))),e=o((()=>import("./gtm.js")));export{e as GoogleTagManager,r as Moengage,t as Pixel};
